import { render, staticRenderFns } from "./Товарный отчет за период1.vue?vue&type=template&id=54b79d66&scoped=true"
import script from "./Товарный отчет за период1.vue?vue&type=script&lang=js"
export * from "./Товарный отчет за период1.vue?vue&type=script&lang=js"
import style0 from "./Товарный отчет за период1.vue?vue&type=style&index=0&id=54b79d66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b79d66",
  null
  
)

export default component.exports